module.exports = __webpack_public_path__ + "./699753f70c29ffed1c1861002833adb4-icon-service-marathon-medium@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-marathon-medium@2x.png
// module id = 1086
// module chunks = 0